import { withNamespaces } from 'react-i18next';
import {
    Col,
    Row,
} from 'reactstrap';

import ComplianceCheck from './components/compliance-check';
import PackagingMaterialOverview from './components/packaging-material-overview';
import PackagingRiskMatrix from './components/packaging-risk-matrix';
import RequirementTracker from './components/requirement-tracker';
import SummaryWidgets from './components/summary-widgets';
import PackagingTonnageTrend from 'src/modules/3rd-party-management/components/ppwr/packaging-tonnage-trend';

const PpwrDashboard = () => (
    <Row className="g-3 mb-4">
        <Col lg="12">
            <SummaryWidgets />
        </Col>

        <Col lg="12">
            <PackagingMaterialOverview />
        </Col>

        <Col lg="12">
            <PackagingTonnageTrend />
        </Col>

        <Col xs="12" md="6">
            <RequirementTracker />
        </Col>
        <Col xs="12" md="6">
            <ComplianceCheck />
        </Col>

        <Col lg="12">
            <PackagingRiskMatrix />
        </Col>
    </Row>
);

export default withNamespaces()(PpwrDashboard);
